import { Component, ChangeDetectionStrategy, Type } from '@angular/core';
import { FieldTypeConfig, FormlyFieldConfig, FieldType } from '@ngx-formly/core';
import { BaseFormlyFieldProps } from '../form-field/public_api';
import { PrimeNGConfig } from 'primeng/api';

interface SwitchProps extends BaseFormlyFieldProps {
    size?: 'small' | 'medium' | 'large' | 'none';
    style?: string;
    labelOn?: string;
    labelOff?: string;
}

export interface FormlySwitchFieldConfig extends FormlyFieldConfig<SwitchProps> {
    type: 'kendo-switch' | Type<FormlyFieldSwitch>;
}

@Component({
    selector: 'formly-field-kendo-switch',
    template: `
    <kendo-switch
        [formControl]="formControl"
        [formlyAttributes]="field"
        [readonly]="props.readonly === true"
        [style]="props.style || style"
        [size]="props.size || 'small'"
        [onLabel]="props.labelOn || labelOn"
        [offLabel]="props.labelOff || labelOff">
      </kendo-switch>
  `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormlyFieldSwitch extends FieldType<FieldTypeConfig<SwitchProps>> {
    style: string;
    labelOn: string;
    labelOff: string;

    constructor(config: PrimeNGConfig) {
        super();
        this.style = "width: 60px;height: 30.3px;"
        this.labelOn = config.getTranslation("common.yes");
        this.labelOff = config.getTranslation("common.no");
    }
}
